// extracted by mini-css-extract-plugin
module.exports = {"container":"ExoIrisScrollyVideo_container__fvRwJ","videoContainer":"ExoIrisScrollyVideo_videoContainer__LKBr4"};